import React from "react";
import {
  LearningActivityCardLink,
  LearningActivityCardButton,
} from "Components/Module/LearningActivityItem/Actions";
import { REMOVE } from "Components/Icons";
import { ATTEST_WAITING } from "domains/programs/constants";
import format from "lib/format";

export const ProgramActions = ({
  program,
  managerView,
  onClick,
  programUrl,
  languageContext,
}) => (
  <>
    {managerView && !program.requested && (
      <LearningActivityCardButton
        onClick={() => onClick(program.activityId)}
        label={languageContext("showprogram")}
      />
    )}

    {(program.requested || program.attestStatus === ATTEST_WAITING) &&
      !managerView && (
        <LearningActivityCardLink
          href={format.url(
            `/activities/ActivityDetails.aspx?inapp=1&id=${program.courseId}`,
          )}
        >
          {languageContext("registerHere")}
        </LearningActivityCardLink>
      )}

    {!managerView &&
      !program.requested &&
      program.attestStatus !== ATTEST_WAITING && (
        <LearningActivityCardLink
          href={programUrl}
          title={`${languageContext("show")} ${program.title}`}
        >
          {languageContext("show")}
        </LearningActivityCardLink>
      )}
  </>
);

export const OnlineCourseActions = ({
  course,
  isManagerOrAdmin,
  onlineCourseURL,
  unregisterFromCourse,
  buttonText,
  languageContext,
}) => (
  <>
    {course.allowUsersToUnregister && !course.completed && (
      <LearningActivityCardButton
        onClick={unregisterFromCourse}
        endIcon={<REMOVE />}
        label={languageContext("unregister")}
        title={languageContext("unregisterFromCourse")}
      />
    )}

    {!isManagerOrAdmin && (
      <LearningActivityCardLink
        href={onlineCourseURL}
        title={`${buttonText} ${course.title}`}
        {...((course.munioURL || course.externalURL) && { target: "_blank" })}
      >
        {buttonText}
      </LearningActivityCardLink>
    )}
  </>
);

export const ClassroomActions = ({
  course,
  isManagerOrAdmin,
  openDetails,
  basePath,
  languageContext,
}) => (
  <>
    {course.requested && !isManagerOrAdmin && (
      <LearningActivityCardLink
        href={`${basePath}activities/ActivityDetails.aspx?inapp=1&id=${course.courseId}`}
        title={`${languageContext("show")} ${course.title}`}
      >
        {languageContext("registerHere")}
      </LearningActivityCardLink>
    )}
    {!course.requested && (
      <LearningActivityCardButton
        onClick={() => openDetails(course)}
        title={`${languageContext("show")} ${course.title}`}
        label={languageContext("show")}
      />
    )}
  </>
);
